import React from 'react';
import ReactPlayer from 'react-player';
import { Cog6ToothIcon } from '@heroicons/react/24/solid';
import ReactTooltip from 'react-tooltip';

interface IqualitySelector {
  onChangeBitrate: (e: any) => void;
  player: React.RefObject<ReactPlayer>;
}

export default function QualitySelector({
  onChangeBitrate,
  player,
}: IqualitySelector) {
  return (
    <>
      <Cog6ToothIcon
        data-tip
        data-for="qualitySelector"
        data-delay-hide="600"
        className="h-6 w-6 cursor-pointer text-white"
        // data-event="click focus"
      />

      <ReactTooltip
        id="qualitySelector"
        place="top"
        effect="solid"
        delayHide={600}
        clickable={true}
      >
        <div>Quality</div>
        <select
          onChange={onChangeBitrate}
          className="mt-2 appearance-none cursor-pointer bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  border-none dark:bg-zinc-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-500 dark:focus:border-gray-500"
        >
          {player.current?.getInternalPlayer('hls')?.['levels'] && (
            <option key={`99-quality-level`} value={-1}>
              Auto
            </option>
          )}
          {player.current
            ?.getInternalPlayer('hls')
            ?.['levels'].map(
              (level: { height: string | number }, id: string | number) => (
                <option key={`${id}-quality-level`} value={id}>
                  {level.height}
                </option>
              )
            )}
        </select>
      </ReactTooltip>
    </>
  );
}
